import {constructUrl, HttpClient} from '../helper/HttpClient';

export type CurrentUserInformation =  {
	name: string;
	email: string;
	employeeNumber: string
}
export async function trackUser(information: CurrentUserInformation): Promise<string> {
    return await new HttpClient().post(constructUrl('userTrack'), JSON.stringify(information));
}